import styled, { device } from "@theme/utils";
export const FollowUsWidgetBox = styled.div``;
export const FollowText = styled.p`
    color: black;
    font-size: 15px;
    margin-bottom: 35px;
`;
